module.exports = __webpack_public_path__ + "img/kt-zlk.cb6f934f.png";